const TZ = 'Asia/Kolkata';
const inrFmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 });
export const inr = (paise: number | null | undefined) => (paise == null ? '—' : inrFmt.format(paise / 100));
/** "1,234.50" → 123450 paise. Returns null for invalid input. Never uses floating-point multiplication. */
export function toPaise(rupees: string): number | null {
  const s = rupees.replace(/[,\s₹]/g, '');
  if (!/^\d+(\.\d{0,2})?$/.test(s)) return null;
  const [r, p = ''] = s.split('.');
  return Number(r) * 100 + Number(p.padEnd(2, '0'));
}
export const fromPaise = (p: number | null | undefined) => (p == null ? '' : (p / 100).toFixed(2));
export const dateTime = (d: string | Date | null | undefined) => (d ? new Intl.DateTimeFormat('en-IN', { timeZone: TZ, day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(d)) : '—');
export const date = (d: string | Date | null | undefined) => (d ? new Intl.DateTimeFormat('en-IN', { timeZone: TZ, day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(d)) : '—');
export const pct = (bps: number) => `${bps / 100}%`;
export const humanize = (s: string) => s.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

export type Tone = 'green' | 'gold' | 'red' | 'blue' | 'grey';
const TONES: Record<string, Tone> = {
  CONFIRMED: 'blue', PROCESSING: 'blue', PACKED: 'blue', SHIPPED: 'blue', OUT_FOR_DELIVERY: 'blue', DELIVERED: 'green',
  PENDING: 'gold', RETURN_REQUESTED: 'gold', REFUND_PROCESSING: 'gold', CANCELLED: 'grey', RETURNED: 'grey', REFUNDED: 'grey',
  CAPTURED: 'green', AUTHORIZED: 'blue', CREATED: 'grey', FAILED: 'red', EXPIRED: 'grey', REFUND_INITIATED: 'gold', PARTIALLY_REFUNDED: 'gold', DISPUTED: 'red',
  ACTIVE: 'green', DRAFT: 'grey', INACTIVE: 'gold', ARCHIVED: 'grey', DISABLED: 'red', DELETED: 'grey',
  IN_STOCK: 'green', LOW_STOCK: 'gold', OUT_OF_STOCK: 'red', PROCESSED: 'green', REQUESTED: 'gold', IGNORED: 'grey', RECEIVED: 'gold',
};
export const toneOf = (status: string): Tone => TONES[status] ?? 'grey';
